"use strict";
import Vue from "vue";
import { mapGetters } from "vuex";
import { ToastPlugin } from "bootstrap-vue";
Vue.use(ToastPlugin);

export const homeMixin = {
  data: {
    enableRefresh: true,
  },
  created: function () {
    this.$refreshHub.$on("home-refreshed", this.refreshHome);
  },
  mounted: function () {
    //elections timeline control height
    setTimeout(calc_height(), 1000);
    setTimeout(calc_height(), 2000);
    setTimeout(calc_height(), 4000);
    setTimeout(calc_height(), 8000);

    function calc_height() {
      return () => {
        const ele23Post = document.querySelector(
          ".elections-home .news-2 .posts",
        );
        if (ele23Post) {
          const ele23PostHeight = ele23Post.offsetHeight;
          var ele23Live = document.querySelector(
            ".elections-home .news-2 .live",
          );
          if (ele23Live) {
            ele23Live.style.maxHeight = ele23PostHeight + "px";
          }
        }
      };
    }
  },
  methods: {
    refreshHome: function () {
      if (this.enableRefresh) {
        this.enableRefresh = false;
        this.hideMessage();
        this.showMessage(
          {
            title: "Actualizar",
            href: "/",
            class: ["btn", "lr"],
          },
          {
            src: "https://s.lalr.co/__assets/lr/images/ultimas-noticias-bg.jpg",
          },
        );
      }
    },
    hideMessage: function () {
      this.$bvToast.hide();
    },
    showMessage: function (title, image) {
      const _self = this;
      const h = this.$createElement;

      let vNodesTitle;
      if (title.modal) {
        vNodesTitle = h(
          "a",
          {
            class: title.class,
            on: {
              click: function () {
                _self.$bvToast.hide();
                _self.openSubscribeModal = true;
              },
            },
          },
          title.title,
        );
      } else if (title.href) {
        vNodesTitle = h(
          "a",
          {
            attrs: { href: title.href },
            class: title.class,
          },
          title.title,
        );
      } else {
        vNodesTitle = title.title;
      }

      const vNodesMsg = h("img", {
        attrs: { src: image.src },
      });
      this.$bvToast.hide();
      this.$bvToast.toast([vNodesMsg], {
        title: [vNodesTitle],
        toaster: "b-toaster-bottom-right",
        toastClass: ["breakingnews-toast"],
        noAutoHide: true,
        appendToast: true,
      });
    },
  },
  computed: {
    ...mapGetters("auth", {
      news: "news",
    }),
  },
};
